import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, put, getStatus } from '../models/base';

export const fetchCompany = createAsyncThunk(
  'company/fetchCompany',
  async (_, { rejectWithValue, getState }) => {
    const { album } = getState().client;

    try {
      const response = await get(`/api/client_companies/${album.company_id}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updateCompany = createAsyncThunk(
  'company/updateCompany',
  async (referralCode, { rejectWithValue, getState }) => {
    let { company } = getState().company;
    const { user } = getState().user;

    const companyId = company?.id || user?.company_id;
    const queryPath = referralCode
      ? `/companies/${companyId}?ref_code=${referralCode}`
      : `/companies/${companyId}`;
    try {
      const response = await put(queryPath, company);
      return response;
    } catch (errors) {
      return rejectWithValue(errors);
    }
  }
);

export const fetchPhotographerCompany = createAsyncThunk(
  'company/fetchPhotographerCompany',
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await get(`/companies/${companyId}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCompanyLogo = createAsyncThunk(
  'album/uploadCompanyLogo',
  async (uploadedFileData, { rejectWithValue, getState }) => {
    const { company } = getState().company;

    try {
      const queryPath = `/companies/${company.id}/upload_logo`;
      const response = await put(queryPath, uploadedFileData);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const checkPermalinkUniqueness = createAsyncThunk(
  'company/checkPermalinkUniqueness',
  async (permalink, { rejectWithValue }) => {
    try {
      const response = await getStatus(
        `/companies/permalink_uniqueness?permalink=${permalink}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error });
    }
  }
);
